<template>
    <div>
        <h4>Timesheets</h4>
        <v-server-table :ref="'payrollList' + assetType" :url="`/payroll?assetType=${assetType}`" :columns="columns" :options="options">

            <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

            </div>

            <div slot="afterFilter" class="ml-2 mb-sm-0 mb-1 mt-sm-0 mt-1">
                <button class="btn btn-default" v-on:click="clearFilters()" title="Clear All Filters">
                    <i class="fas fa-ban"></i>
                </button>
                <button class="btn btn-default" v-on:click="showFilters = !showFilters" title="Apply Filters">
                    <i class="fas fa-filter"></i>
                    <span class="badge badge-danger" v-if="filterCount > 0">{{ filterCount }}</span>
                </button>
            </div>

            <template slot="id" slot-scope="props">
                <router-link :to="`/payroll/${props.row.id}`" class="btn btn-sm btn-secondary">View</router-link>
            </template>

            <template slot="time_in" slot-scope="props">
                {{ props.row.time_in | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
            </template>

            <template slot="time_out" slot-scope="props">
                {{ props.row.time_out | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
            </template>

            <template slot="hours_worked" slot-scope="props">
                <span v-if="props.row.hours_worked > 0">{{ props.row.hours_worked }}</span>&nbsp;
                <span v-if="props.row.paid_hours_off && props.row.paid_hours_off > 0" title="Paid Hours Off">({{ props.row.paid_hours_off }})</span>
            </template>

            <template slot="timesheet_type_name" slot-scope="props">
                {{ props.row.timesheet_type_name }}
            </template>

            <template slot="employee_sign_off" slot-scope="props">
                <button v-if="canUserApprove(props.row)" @click="approveTimesheet(props.row)" :disabled="saving" class="btn btn-sm btn-success">Approve</button>
                <label v-else-if="props.row.employee_sign_off">{{ props.row.employee_sign_off | moment('timezone', userTimezone, "MM/DD/YYYY h:mm a") }}</label>
                <label v-else class="badge badge-danger">No</label>
            </template>

            <template slot="manager_sign_off" slot-scope="props">
                <button v-if="canManagerApprove(props.row)" @click="approveTimesheet(props.row)" :disabled="saving" class="btn btn-sm btn-success">Approve</button>
                <label v-else-if="props.row.manager_sign_off">{{ props.row.manager_sign_off | moment('timezone', userTimezone, "MM/DD/YYYY h:mm a") }}</label>
                <label v-else class="badge badge-danger">No</label>
            </template>


        </v-server-table>

        <h4>
            Timelogs <span v-if="assetType === 'Dashboard'">- Last 30 Days Only</span>
            <button v-if="false" :disabled="saving || !(filters['payroll_timesheets.start_date'] && filters['payroll_timesheets.end_date'] && filters['payroll_timesheets.user_id'])" @click="bulkApproveTimelogs" class="btn btn-sm btn-success">Approve All</button>
        </h4>
        <div v-if="assetType != 'Dashboard' && (!filters['payroll_timesheets.start_date'] || !filters['payroll_timesheets.end_date'])">-- The date filters must be set to see timelogs --</div>
        <v-client-table v-else :columns="timelogCols" :options="timelogOptions" :data="timelogs" class="vertical-headers">
            <template v-for="(customer_name, customer_id) in customer_names" :slot="`h__customer${customer_id}`">
              {{ customer_name }}
            </template>

            <template slot="day" slot-scope="props">
                {{ props.row.day | moment("MM/DD/YYYY") }}
            </template>

            <template slot="user_id" slot-scope="props">
                {{ getUserName(props.row.user_id) }}
            </template>

            <template slot="employee_sign_off" slot-scope="props">
                <button v-if="canUserApproveTimelog(props.row)" @click="approveTimelog(props.row)" :disabled="saving" class="btn btn-sm btn-success">Approve</button>
                <label v-else-if="props.row.employee_sign_off">{{ props.row.employee_sign_off | moment('timezone', userTimezone, "MM/DD/YYYY h:mm a") }}</label>
                <label v-else class="badge badge-danger">No</label>
            </template>

            <template slot="manager_sign_off" slot-scope="props">
                <button v-if="canManagerApproveTimelog(props.row)" @click="approveTimelog(props.row)" :disabled="saving" class="btn btn-sm btn-success">Approve</button>
                <label v-else-if="props.row.manager_sign_off">{{ props.row.manager_sign_off | moment('timezone', userTimezone, "MM/DD/YYYY h:mm a") }}</label>
                <label v-else class="badge badge-danger">No</label>
            </template>
        </v-client-table>

        <b-modal v-model="showFilters" :ref="'payrollListFilters' + assetType" title="Entry Filters" size="lg" no-fade ok-title="Apply Filters" @ok="applyFilters()">
            <!-- date of timesheet -->
            <!-- employee -->
            <!-- manager? -->
            <!-- signed off? -->
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Start Date:</div>
                <div class="col-md-7 col-12">
                    <b-form-datepicker v-model="filters['payroll_timesheets.start_date']"></b-form-datepicker>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">End Date:</div>
                <div class="col-md-7 col-12">
                    <b-form-datepicker v-model="filters['payroll_timesheets.end_date']"></b-form-datepicker>
                <a href="javascript:void(0)" @click="setLastWeek()">Last Week</a>&nbsp;|
                <a href="javascript:void(0)" @click="setThisWeek()">This Week</a>&nbsp;|
                <a href="javascript:void(0)" @click="setToday()">Today</a>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">User:</div>
                <div class="col-md-7 col-12">
                    <v-select
                        v-model="filters['payroll_timesheets.user_id']"
                        :options="users"
                        :reduce="user => user.id"
                        label="name"
                        multiple
                        placeholder="-- Select a User --"></v-select>

                    <a href="javascript:void(0)" @click="assignedToMe()">Assigned To Me</a>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Time Off Type:</div>
                <div class="col-md-7 col-12">
                    <v-select
                        v-model="filters['payroll_timesheets.timesheet_type_id']"
                        :options="timesheet_types"
                        :reduce="timesheet_type => timesheet_type.id"
                        label="timesheet_type_name"
                        multiple
                        placeholder="-- Select Timesheet Type --"></v-select>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        props: {
            assetType: {
                type: String,
                required: false
            },

            showCreateBtn: {
                type: Boolean,
                default: false,
            },

            search: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                userTimezone: this.$root.timezone,
                showFilters: false,
                columns: ['id','user','time_in','time_out','location', 'hours_worked','employee_sign_off','manager_sign_off','timesheet_type_name'],
                saving: false,
                timelogs: [],
                approvals: [],
                customers: [],
                customer_names: {},
                timesheet_types: {},
                options: {
                    headings: {
                        id: 'Actions',
                        user: 'User',
                        time_in: 'Time In',
                        time_out: 'Time Out',
                        location: 'Location',
                        hours_worked: 'Calculated Total Hours',
                        employee_sign_off: 'Employee Verified',
                        manager_sign_off: 'Manager Verified',
                        timesheet_type_name: 'Time Off Type'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'payroll_timesheets.time_in',
                    },
                    texts:{
                        filterPlaceholder:"Search Entries",
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('payrollCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Add the type
                        data.filters = this.filters;

                        if (this.assetType == 'Dashboard' || (this.filters['payroll_timesheets.start_date'] && this.filters['payroll_timesheets.end_date']))
                        {
                            this.getTimelogs();
                        }

                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },
                timelogOptions: {
                    skin: 'table table-striped table-bordered table-sm',
                    perPage: this.assetType == 'Dashboard' ? 5 : 25,
                    headings: {
                        day: 'Date',
                        user_id: 'User',
                        employee_sign_off: 'Employee Verified',
                        manager_sign_off: 'Manager Verified',
                    },
                    texts:{
                        filterPlaceholder:"Search Members",
                    },
                    uniqueKey: 'id',
                    filterable: false,
                },

                filters: {
                    'payroll_timesheets.start_date': null,
                    'payroll_timesheets.end_date': null,
                    'payroll_timesheets.user_id': this.assetType == 'Dashboard' ? null : this.$store.state.user.id,
                    'payroll_timesheets.timesheet_type_id': null
                },
            }
        },

        computed: {

            timelogCols() {
                let cols = ['day', 'user_id'];
                for(let i = 0; i < this.customers.length; i++)
                {
                    cols.push('customer'+this.customers[i]);
                }
                cols.push('employee_sign_off');
                cols.push('manager_sign_off');

                return cols;
            },

            users(){
                //Users are single string names, so we need to split them to sort it better
                var user_names = [];

                //Loop and Build
                for (var i = this.$store.state.users.length - 1; i >= 0; i--)
                {
                    //Setup
                    var name_parts = this.$store.state.users[i].name.split(' ');

                    //Setup Last name
                    var first_name = name_parts.shift();

                    //Build
                    user_names.push({id: this.$store.state.users[i].id, first_name: first_name, last_name: name_parts.join(' '), name: (name_parts.length > 0 ? name_parts.join(' ') + ', ' : '') + first_name});
                }

                //Sort the names
                user_names.sort(function(a, b) {
                    var textA = a.last_name.toUpperCase();
                    var textB = b.last_name.toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                });

                //Using a computed allows changes to the state to be rendered
                //return this.$store.state.users;
                return user_names;
            },

            filterCount(){
                //Get the keys
                var keys = Object.keys(this.filters);
                var count = 0;

                //Loop
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Check the value
                    if(Array.isArray(this.filters[keys[i]]) && this.filters[keys[i]].length > 0)
                    {
                        count++;
                    }
                    else if(this.filters[keys[i]] != null && this.filters[keys[i]] != '')
                    {
                        count++;
                    }
                }

                //Send it
                return count;
            },
        },

        methods: {
            getUserName(user_id) {
                for (let i = 0; i < this.users.length; i++)
                {
                    if (this.users[i].id == user_id)
                    {
                        return this.users[i].name;
                    }
                }
            },


            getTimelogs() {
                //Build the Filters
                let filters = JSON.parse(JSON.stringify(this.filters));

                //Append the Asset Type
                filters['assetType'] = this.assetType;

                //Send the Request
                this.$http.get('timelogs/day-list', filters).then(response => {
                    this.timelogs = response.data.timelogs || [];
                    this.customers = response.data.customers || [];
                    this.customer_names = response.data.customer_names || {};
                });
            },

            canUserApprove(timesheet) {
                if (timesheet.time_out && timesheet.user_id == this.$store.state.user.id && !timesheet.employee_sign_off)
                {
                    return true;
                }
                return false;
            },

            canManagerApprove(timesheet) {
                //Check if already completed
                if(timesheet.manager_sign_off != null)
                {
                    return false;
                }

                //Check it
                if (timesheet.time_out && timesheet.employee_sign_off && (timesheet.location_manager_id == this.$store.state.user.id || this.$root.arrayIncludes(timesheet.proxy_manager_ids, this.$store.state.user.id)))
                {
                    return true;
                }

                //Default
                return false;
            },

            approveTimesheet(timesheet) {
                if (timesheet.user_id == this.$store.state.user.id)
                {
                    if (!confirm('This will lock edits for you on this timesheet. Are you sure you want to continue?'))
                    {
                        return;
                    }
                }

                this.saving = true;
                this.$http
                .post(`payroll/${timesheet.id}/approve`, null)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Timesheet Approved');

                    this.$refs['payrollList' + this.assetType].refresh();
                })
                .catch(error => {
                    //Alert the user
                    this.$toastr.e(error.response.data, 'Failed to Approve Timesheet');
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            },

            canUserApproveTimelog(timelog) {
                if (timelog.user_id == this.$store.state.user.id && !timelog.employee_sign_off)
                {
                    return true;
                }
                return false;
            },

            canManagerApproveTimelog(timelog) {
                if (timelog.employee_sign_off && !timelog.manager_sign_off)
                {
                    for(let i = 0; i < timelog.managers.length; i++)
                    {
                        if (this.$store.state.user.id == timelog.managers[i])
                        {
                            return true;
                        }
                    }
                }
                return false;
            },

            approveTimelog(timelog) {
                this.saving = true;
                this.$http
                .post('timelogs/approve', {day: timelog.day, user_id: timelog.user_id})
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Timelogs Approved');
                    this.$set(timelog, 'manager_sign_off', new Date());
                    this.getTimelogs();
                })
                .catch(error => {
                    //Alert the user
                    this.$toastr.e(error.response.data, 'Failed to Approve Timelogs');
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            },

            bulkApproveTimelogs() {
                // All filters must be set in order to do this
                this.saving = true;
                this.$http
                .post('timelogs/bulk-approve', {
                    start_date: this.filters['payroll_timesheets.start_date'],
                    end_date: this.filters['payroll_timesheets.end_date'],
                    user_id: this.filters['payroll_timesheets.user_id'],
                })
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Timelogs Approved');
                    this.getTimelogs();
                })
                .catch(error => {
                    //Alert the user
                    this.$toastr.e(error.response.data, 'Failed to Approve Timelogs');
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            },

            getFilters(){
                //Check the store for the filters
                // if(this.$store.state.payrollFilters)
                // {
                //     //Set it
                //     this.setFilters(this.$store.state.payrollFilters);

                //     //Stop here
                //     //return;
                // }

                //Send it
                this.$http.get('/payroll/filters')
                    .then(response => {
                        //Set the part
                        // this.setFilters(response.data.timesheet_types);

                        this.timesheet_types = response.data.timesheet_types;

                        //Commmit
                        this.$store.commit('payrollFilters', response.data.timesheet_types);

                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            setFilters(data){

            },

            clearFilters(){
                //Get the keys
                var keys = Object.keys(this.filters);
                var count = 0;

                //Loop
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Check the value
                    if(Array.isArray(this.filters[keys[i]]))
                    {
                        this.filters[keys[i]] = [];
                    }
                    else
                    {
                        this.filters[keys[i]] = null;
                    }
                }

                //Refresh
                this.$refs['payrollList' + this.assetType].refresh();
            },

            applyFilters(){
                //Apply the filters
                this.$refs['payrollList' + this.assetType].refresh();
            },

            assignedToMe(){
                //Set the filter
                this.filters['payroll_timesheets.user_id'] = this.$store.state.user.id;
            },

            setLastWeek() {
                this.filters['payroll_timesheets.start_date'] = moment().tz(this.$root.timezone).subtract(1, 'week').startOf('week').format("YYYY-MM-DD");
                this.filters['payroll_timesheets.end_date'] = moment().tz(this.$root.timezone).subtract(1, 'week').endOf('week').format("YYYY-MM-DD");
            },

            setThisWeek() {
                this.filters['payroll_timesheets.start_date'] = moment().tz(this.$root.timezone).startOf('week').format("YYYY-MM-DD");
                this.filters['payroll_timesheets.end_date'] = moment().tz(this.$root.timezone).endOf('week').format("YYYY-MM-DD");
            },

            setToday() {
                this.filters['payroll_timesheets.start_date'] = moment().tz(this.$root.timezone).format("YYYY-MM-DD");
                this.filters['payroll_timesheets.end_date'] = moment().tz(this.$root.timezone).format("YYYY-MM-DD");
            },
        },

        mounted() {
            //Get the filtes
            this.getFilters();

            //Check for a search
            if(this.search)
            {
                this.$refs['payrollList' + this.assetType].setFilter(this.search);
                this.$refs['payrollList' + this.assetType].refresh();
            }
        }
    }
</script>
